const getDefaultState = () => {
  return {
    datauser: {
      id: null,
      nombres: null,
      apellidos: null,
      tipo_usuario: null,
      token: null,
      username: null,
      cambiar_password: null,
    }
  };
};

export const mutations = {
  resetState(state) {
    //reset del state
    state.datauser={...getDefaultState().datauser};
    state.usuario=null;
  },
  setDataUser(state, payload) {
    //actualiza los datos del usuario
    state.datauser = payload;
  },
  setUsuario(state, payload) {
    //actualiza los datos del usuario medico en edicion
    state.usuario = { ...payload };
  },
  setChangePassword(state, payload) {
    //actualiza si debe hacer cambio de clave
    state.datauser.cambiar_password = payload;
  },
};
